// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"805":"9ed980ed03c9be6ab4e1","839":"cf00ca5117f1c10baf10","879":"86cbd8a3af5f7fcf9784","937":"d80e1cf643296228a00f","951":"2e9c7e92accc240ac8ab"}[chunkId] + ".js";
};